import { useAtomValue } from 'jotai';
import { useEffect, useRef } from 'react';
import { ESCALATION_AUDIO_NOTIF_FILE } from '../constants';
import { escalationAudioNotifyAtom } from '../state/state';
import { dismissToast, toast } from './toast';

const NEW_ESCALATION_TOAST_ID_PREFIX = 'audio-notify-new-escalation';

export function useEscalationSoundAlert(
  escalationIds: string[] | undefined,
  toastIdSuffix = ''
) {
  const audioNotify = useAtomValue(escalationAudioNotifyAtom);
  const previousIdsRef = useRef<Set<string>>();
  const toastId = `${NEW_ESCALATION_TOAST_ID_PREFIX}${toastIdSuffix}`;

  useEffect(() => {
    if (escalationIds === undefined) {
      return;
    }

    const previousIds = previousIdsRef.current;
    previousIdsRef.current = new Set(escalationIds);

    if (previousIds === undefined) {
      return;
    }

    const newIds = escalationIds.filter((id) => !previousIds.has(id));

    if (newIds.length === 0) {
      if (escalationIds.length === 0) {
        dismissToast(toastId);
      }
      return;
    }

    toast(
      newIds.length > 1 ? `${newIds.length} new escalations` : 'New escalation',
      {
        type: 'warning',
        audio: audioNotify,
        audioFileName: ESCALATION_AUDIO_NOTIF_FILE,
        id: toastId,
      }
    );
  }, [escalationIds, audioNotify, toastId]);
}

export default useEscalationSoundAlert;
